import request from "@/plugins/axiosRequest";

const url = "/api/v1/timezones";

export function fetchList(query) {
  return request({
    url: url,
    method: "get",
    params: query
  });
}